import { Types } from './header';

const INITIAL_STATE = {
  crs: null,
  hasTemporalData: false,
  dateRange: null,
  roiBBox: null,
  modelBBox: null,
  modeledCoastlinesGeoJSON: null,
  modeledCoastlinesDisplayGeoJSON: null,
};

/**
 * @function reducer
 * @description Redux reducer for the Shore-S model duck. Holds the parsed `.mat`/CSV model output
 * (`SET_MODEL`) — CRS, temporal coverage, derived ROI bbox and modeled-coastline GeoJSONs — that
 * seeds the rest of the Shore-S flow (image search ROI, analysis reprojection, export baseline).
 * @param {Object} [state=INITIAL_STATE] - Current Shore-S model state.
 * @param {Object} action - Dispatched Redux action.
 * **Called by:
 * @see {Redux store} - registered as the "shoreSModel" reducer.
 * @memberof module:ShoreS
 * @returns {Object} The next Shore-S model state.
 */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.SET_MODEL:
      return { ...state, ...action.payload };

    case Types.RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
